import React, { useState, useCallback } from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/contactus_background.jpg";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import { set } from "date-fns";
import { faL } from "@fortawesome/free-solid-svg-icons";
import "./Careers.css"

const CareerPage = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isNameValid, setIsNameValid] = useState(false);
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleInputChange = (e, setValue, label) => {
    setValue(e.target.value);
  };

  const sendTheResume = async () => {
    setIsLoading(true);
    const regexMap = {
      name: /^[A-Za-z\s]{5,}$/,
      address: /^[A-Za-z0-9\s]*$/,
      postalCode: /^[A-Za-z0-9\s]*$/,
      email: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      phone: /^(\+?1[ .-]?)?\(?\d{3}\)?[ .-]?\d{3}[ .-]?\d{4}$/,
    };
    if (
      !regexMap["name"].test(fullName) ||
      !regexMap["email"].test(email) ||
      !regexMap["phone"].test(phone)
    ) {
      alert("Please fill all required fields with correct format.");
      setIsLoading(false);
      return;
    }
    if (file === null) {
      alert("Please upload your resume/CV");
      setIsLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append("pdfFile", file);
    formData.append("name", fullName);
    formData.append("email", email);
    formData.append("phone", phone);
    await axiosReqConfig(`${API_IP}/api/career-resume`, "POST", formData);
    setIsCompleted(true);
  };

  const scrollToElement = () => {
    const element = document.getElementById("apply-now-section");
    if (element) {
      const elementPosition = element.offsetTop;
      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="CR-container">
      <div
        className="CR-hero"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="CR-hero-content">
          <h1 className="CR-title">A Career with Purpose and Heart</h1>
          <div className="CR-badges">
            <span className="CR-badge">📍 Victoria, BC, Canada</span>
            <span className="CR-badge">💰 $23 - $28 / hour</span>
          </div>
          <p className="CR-hero-desc">
            iCare Village is a home care service provider dedicated to
            supporting seniors to live safely and independently at home. We are
            growing our care team and are looking for compassionate care aides,
            nursing students, and experienced care professionals who want
            flexible, rewarding work with purpose.
          </p>
          <button className="CR-hero-btn" onClick={scrollToElement}>
            Apply Now
          </button>
        </div>
      </div>

      <div className="CR-main-content" id="apply-now-section">
        <div className="CR-form-wrapper">
          {!isCompleted ? (
            <div className="CR-form-container">
              <h2>Submit Your Application</h2>
              <p className="CR-required-note">
                Fields marked with * are required
              </p>

              <div className="CR-form-group">
                <label htmlFor="CareerFullName">Your Full Name *</label>
                <input
                  type="text"
                  id="CareerFullName"
                  name="CareerFullName"
                  value={fullName}
                  placeholder="e.g., Jane Smith"
                  onChange={(e) => handleInputChange(e, setFullName, "name")}
                  required
                />
              </div>

              <div className="CR-form-group">
                <label htmlFor="CareerEmail">Email *</label>
                <input
                  type="email"
                  id="CareerEmail"
                  name="CareerEmail"
                  value={email}
                  placeholder="e.g., janesmith@email.com"
                  onChange={(e) => handleInputChange(e, setEmail, "email")}
                  required
                />
              </div>

              <div className="CR-form-group">
                <label htmlFor="CareerPhone">Your Phone *</label>
                <input
                  type="tel"
                  id="CareerPhone"
                  name="CareerPhone"
                  value={phone}
                  placeholder="e.g., 250-123-4567"
                  onChange={(e) => handleInputChange(e, setPhone, "phone")}
                  required
                />
              </div>

              <div className="CR-form-group">
                <label>Resume/CV *</label>
                <div className="CR-file-upload-wrapper">
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={handleFileChange}
                    className="CR-file-input"
                  />
                </div>
                <p className="CR-form-note">
                  Please upload your resume outlining relevant care, health, or
                  support experience.
                </p>
              </div>

              <div className="CR-form-group">
                <label className="CR-checkbox-title">
                  Why Join iCare Village? (Select all that apply)
                </label>
                <div className="CR-checkbox-grid">
                  {[
                    "Meaningful work supporting seniors in their homes",
                    "Flexible scheduling with local clients",
                    "Competitive hourly wages",
                    "Supportive team and clear care standards",
                    "Opportunity to grow in community-based care",
                  ].map((item, index) => (
                    <div key={index} className="CR-checkbox-item">
                      <input
                        type="checkbox"
                        id={`reason-${index}`}
                        name="joinReason"
                        value={item}
                        className="CR-checkbox-input"
                      />
                      <label
                        htmlFor={`reason-${index}`}
                        className="CR-checkbox-label"
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <button
                onClick={sendTheResume}
                disabled={isLoading}
                className="CR-submit-btn"
                style={{ opacity: isLoading ? 0.7 : 1 }}
              >
                {isLoading ? "Loading..." : "Submit Application"}
              </button>
              <p className="CR-form-note-bottom">
                All applications are reviewed by our care leadership team.
                Shortlisted candidates will be contacted for next steps,
                including screening and onboarding requirements.
              </p>
            </div>
          ) : (
            <div className="CR-success-container">
              <img
                src={require(`../images/booking_accepted_icon.webp`)}
                alt="Success"
                className="CR-success-icon"
              />
              <h3>
                You have successfully submitted your application.
                <br />
                We will get back to you soon.
              </h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CareerPage;
